import React from 'react';
import Modal from './modal';
import SmartBlock from '../../smart/block';

export default class Block extends SmartBlock {
  renderTable() {
    const { data } = this.state;

    if (data === '') return null;

    const {
      commission_fee_percent,
      booking_ttl_seconds,
      payment_method_configuration,
      venue_admin_payment_method_configuration
    } = data;

    return (
      <table className="table table-striped table-sm">
        <tbody>
          <tr>
            <td style={{ width: 500 }}>
              <strong>Commission fee for all transactions (%)</strong>
            </td>
            <td>
              {commission_fee_percent}
            </td>
          </tr>
          <tr>
            <td style={{ width: 500 }}>
              <strong>Booking TTL (seconds)</strong>
            </td>
            <td>
              {booking_ttl_seconds}
            </td>
          </tr>

          <tr>
            <td style={{ width: 500 }}>
              <strong>Payment Method Configuration (blank = default)</strong>
            </td>
            <td>
              {payment_method_configuration}
            </td>
          </tr>

          <tr>
            <td style={{ width: 500 }}>
              <strong>Venue Admin Payment Method Configuration (blank = default)</strong>
            </td>
            <td>
              {venue_admin_payment_method_configuration}
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  render() {
    return (
      <div>
        <Modal {...this.props} />
        {this.renderTable()}
      </div>
    )
  }
}

